var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isDebugOptionsEmpty ? [!_vm.isDebugModeOn ? _c('div', {
    class: _vm.$style.openDebugMode,
    on: {
      "click": function ($event) {
        _vm.isDebugModeOn = true;
      }
    }
  }, [_vm._v("Open Debug Mode")]) : _vm._e(), _vm.isDebugModeOn ? _c('div', {
    class: _vm.$style.openDebugMode,
    on: {
      "click": function ($event) {
        _vm.isDebugModeOn = false;
      }
    }
  }, [_vm._v("Close Debug Mode")]) : _vm._e(), _vm.isDebugModeOn ? _c('div', {
    class: _vm.$style.debugModeWrapper
  }) : _vm._e(), _vm.isDebugModeOn ? _c('div', {
    class: _vm.$style.debugOptionsContainer
  }, _vm._l(_vm.debugOptions[_vm.$route.name], function (debugOption, debugKey) {
    return _c('span', {
      key: debugKey,
      on: {
        "click": function ($event) {
          var _vm$setDebugOptions;
          return _vm.setDebugOptions((_vm$setDebugOptions = {}, _vm$setDebugOptions[debugKey] = !debugOption, _vm$setDebugOptions));
        }
      }
    }, [_vm._v(" " + _vm._s(_vm._.startCase(debugKey)) + " : " + _vm._s(debugOption) + " ")]);
  }), 0) : _vm._e()] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }